import React from 'react'
import { ButtonSeeker, IconSeeker } from '@ui-seeker/core'
import {MAPPING_TYPE} from "./@constants";
import { secondaryButtonSx } from '@components'


export default function UploadXlsTemplate({path}) {

    const url = path === MAPPING_TYPE.ACRISS
        ? 'https://storage.googleapis.com/price-seeker-rentacar-reports-custom-csv/CustomCsvAcriss.xlsx'
        : 'https://storage.googleapis.com/price-seeker-rentacar-reports-custom-csv/CustomCsvCategories.xlsx'

    return <ButtonSeeker
        variant="outlined"
        sx={secondaryButtonSx}
        startIcon={<IconSeeker icon="file-arrow-down"/>}
        onClick={e => {
            e.preventDefault()
            window.open(url)
        }}
        tooltip="Download example template for CSV. Tip: OFFICE NAME, OFFICE COUNTRY, WEB and PROVIDERS accept multiple values separated by commas."
    >
        Download Example
    </ButtonSeeker>

}